'use strict';

var React = require('react'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    Loader = require('../atoms/Loader'),
    Icon = require('../atoms/Icon'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    formatTime = require('../utils/formatTime'),
    createFlexibleImageQueueMixin = require('../mixins/createFlexibleImageQueueMixin'),
    { PropTypes } = React;

require('./legacy/Section.less');
require('./legacy/EditorMedia.less');

var EditorVideo = React.createClass({
  mixins: [ClassNameMixin, PureRenderMixin, createFlexibleImageQueueMixin(1)],

  propTypes: {
    url: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    username: PropTypes.string.isRequired,
    duration: PropTypes.number.isRequired,
    background: PropTypes.shape({
      url: PropTypes.string.isRequired
    }),
    isBackgroundReady: PropTypes.bool.isRequired
  },

  getCSSModifiers() {
    return [
      this.props.isBackgroundReady && 'ready'
    ];
  },

  getImageOptions() {
    return {
      image: this.props.background,
      mode: 'scale_crop',
      sizes: {
        thumb: true,
        small: true,
        normal: true,
        retina: window.devicePixelRatio > 1.5
      }
    };
  },

  componentDidUpdate(prevProps) {
    if (prevProps.background !== this.props.background) {
      this.updateImageQueue();
    }
  },

  render() {
    var isReady = this.props.isBackgroundReady;

    return (
      <div className={this.getClassName()}>
        {!isReady && <Loader absoluteCenter />}
        {isReady && this.renderBackground()}
        {isReady && this.renderPlayer()}
      </div>
    );
  },

  renderBackground() {
    var { background } = this.props,
        style;

    if (background) {
      style = {
        backgroundImage: this.getBackgroundImageUrl(),
        backgroundSize: 'cover'
      };
    }

    return (
      <div className='editor-Section-background' style={style}>
        {this.renderLoaderImg()}
      </div>
    );
  },

  renderPlayer() {
    var { title, username, duration } = this.props;

    return (
      <div className='EditorMedia-wrapper'>
        <div className='EditorMedia-badge'>
          <Icon className='EditorMedia-icon'
                name='video'
                size='large'
                mode='stroke' />
          <div className='EditorMedia-duration'>
            {formatTime(duration)}
          </div>
        </div>

        <div className='EditorMedia-info'>
          <div className='EditorMedia-title'>{title}</div>
          <div className='EditorMedia-author'>{username}</div>
        </div>
      </div>
    );
  }
});

module.exports = EditorVideo;



/** WEBPACK FOOTER **
 ** ./editor/EditorVideo.jsx
 **/